<template>
    <div class="topPageCon">
        <div class="top" v-if="(fromL.admin.banner && fromL.admin.banner.length == 0) || !fromL.admin.banner">
            <div class="topBlock">
                <div class="topTit" style="display: flex;">
                    <div>{{ lang.Welcometouse }}</div>
                    <!-- {{ fromL.basics }} -->
                    <div style="color: #0354D7;margin: 0 15px;">{{ fromL.basics.title?fromL.basics.title:lang.CocoaPlatform }}</div>
                    <!-- <div style="color: #0354D7;margin: 0 15px;"><span v-if="roleUser.orgName">{{roleUser.orgName}}—</span>{{ roleUser.schoolName }}</div>
                    <div>AI平台！</div> -->
                </div>
                <div class="topDetail">
                    <!-- <div>{{ lang.Welcometouse2 }}</div> -->
                     {{ fromL.basics.brief }}
                </div>
            </div>
            <img style="width: 150px;object-fit: cover;transform: scaleX(-1);" src="../assets/img/cocoloading.gif" alt="">
        </div>
        <div style="width: 100%;height: 100%;object-fit: cover;border-radius: 10px;height: 300px;margin-bottom: 14px;" 
            v-if="fromL.admin.banner && fromL.admin.banner.length == 1"
            >
                <img style="width: 100%;height: 100%;object-fit: cover;border-radius: 10px;" 
                :src="fromL.admin.banner[0].src" alt="" @click="gotoBanner(fromL.admin.banner[0].url)">
        </div>

        <div class="CarO" v-if="fromL.admin.banner && fromL.admin.banner.length > 1">
            <el-carousel style="width: 100%;" indicator-position="outside">
                <el-carousel-item v-for="(i,index) in fromL.admin.banner" :key="index">
                    <img style="width: 100%;height: 100%;object-fit: cover;border-radius: 10px;" 
                    @click="gotoBanner(i.url)"
                    :src="i.src" alt="">
                </el-carousel-item>
            </el-carousel>
        </div>

        <div  v-if="roleUser.type == 2">
            <div class="enterClass" v-if="!enterClassDialogVisible">
                <div class="enterClassTit" @click="enterClassbtn">
                    {{ lang.ssEnterClass }}
                </div>
            </div>
            <div class="enterClassDialog" v-if="enterClassDialogVisible">
                <div class="enterClassTit2">
                    {{ lang.randomcode }}
                </div>
                <div class="enterClassInput">
                    <el-input v-model.trim="code" :placeholder="lang.enterrandomcode + '...'"></el-input>
                    <div class="enterClassBtn" @click="enterClassConfirm">
                        {{ lang.ssEnterClass }}
                    </div>
                </div>
                
            </div>
        </div>
        

        <template v-if="roleUser.type == 1">
               

                <!-- 平台应用  -->

                <!-- 荔园 -->
                <div v-if="mergedList.includes(roleUser.org) && roleUser.type == 1" class="TabListAdmin">
                    <div
                        @mouseenter="lysetHovered(index, true)"
                        @mouseleave="lysetHovered(index, false)"
                        class="TabListAll2"
                        @click="openApp2(item)" 
                        v-for="(item,index) in liyuanTab" 
                        :key="index+'1p'">
                            <img
                            style="position: absolute;top: -40%;left: 50%;width: 120px;height: 140px;transform: translate(-50%,0);" 
                            :src="item.hovered ? item.hoverIcon : item.icon" 
                            alt="">
                        <span class="tabTit">{{ item.name }}</span>
                    </div>
                </div>
                <!-- 非荔园  -->
                <div v-else  class="TabList" :class="[this.colfour.includes(this.roleUser.organizeid) ? 'TabListF' : '']">
                    <div
                        @mouseenter="setHovered(index, true)"
                        @mouseleave="setHovered(index, false)"
                        class="TabListAll"
                        @click="openApp(item)" 
                        v-for="(item,index) in tabList" 
                        :key="index+'1p'">
                        <div class="TabListCon">
                            <div v-for="(p,pin) in AppCon(item.url)" :key="pin+'p'">
                                <img class="imgApp"
                                :src="tabList[index].hovered ? p.hoverIcon ? p.hoverIcon : p.platformIcon : p.platformIcon" alt="">
                                <div class="TabListName" 
                                    :style="{width: p.name.length <= 6 ? '6em' : p.name.length === 7 ? '5em' : '6em'}">
                                    {{ p.name }}
                                </div>
                            </div>
                            <div class="TabListBri">
                                <el-tooltip class="item" effect="light" :content="item.description" placement="bottom">
                                    <span>
                                        <!-- {{ item.description }} -->
                                    </span>
                                </el-tooltip>
                            </div>
                        </div>
                            
                    </div>
                </div>

                <!-- 常见应用  -->
                <div class="footCon" v-if="fromL.admin.cocoFlowShow && roleUser.type == 1 && this.$region != 'com'">
                    <div class="footConLeft">
                        <img v-if="fromL.basics.cocoFlow" :src="fromL.basics.cocoFlow" alt="">

                        <div v-else style="min-width: 150px;display: flex;flex-direction: column;justify-content: flex-end;">
                            <img class="CutImg" src="../assets/img/dong.png" alt="">
                            <div class="CocoTit">
                                COCO FLOW
                            </div>
                        </div>
                        
                    </div>

                    <div style="display: flex;gap: 16px;flex: 1;">
                        <div class="footList">
                            <div class="footListCon" v-for="(item,index) in admincocoFlow" @click="openNewWindow(item)" :key="index+'2p'">
                                <div class="footListConimg">
                                    <img v-if="fromL.admin.cocoFlow.length == 0" 
                                    class="footListConimgPic"
                                    :src="appImgList[index]" alt="">

                                    <img v-else-if="fromL.admin.cocoFlow[index].setIcon" 
                                    class="footListConimgPic"
                                    :src="fromL.admin.cocoFlow[index].setIcon" alt="">

                                    <img
                                    style="margin-bottom: 12px;height: 40px;width: 40px;object-fit: contain;"  
                                    v-else :src="JSON.parse(item.json).icon" alt="">
                                </div>
                                
                                    
                                <div class="TabListName2">
                                    <el-tooltip class="item" effect="light" :content="item.name" placement="bottom">
                                        <span>
                                            {{ item.name }}
                                        </span>
                                    </el-tooltip>
                                </div>
                                <div class="TabListBri">
                                    <el-tooltip class="item" effect="light" :content="item.detail" placement="bottom">
                                        <span>
                                            {{ item.detail }}
                                        </span>
                                    </el-tooltip>
                                </div>
                                <!-- <div class="cha" @click.stop="delApp(item.lid)">
                                    <img style="width: 20px;" src="../assets/img/cha.svg" alt="">
                                </div> -->
                            </div>
                            <div class="footListCon" @click="lookMore">
                                <div class="footListConimg">
                                    <i style="color: #1662E4;font-size: 22px;" class="el-icon-more"></i>
                                </div>
                                <div class="TabListName2">
                                    <span>
                                    {{ this.lang.Viewmore }}
                                    </span>
                                </div>
                                <div class="TabListBri">
                                        <span>
                                            {{ this.lang.viewmoreAI }}
                                        </span>
                                </div>
                            </div>
                        </div>

                        <div v-if="CocoFlowList.length" class="footList2">
                            <div class="footListCon6" v-for="(item,index) in CocoFlowList" @click="openNewWindow(item)" :key="index+'4p'">
                                <div class="footListConimg">
                                    <!-- <img style="margin-bottom: 12px;height: 24px;width: 22px;" :src="JSON.parse(item.json).icon" alt=""> -->
                                    <img v-if="fromL.admin.cocoFlow2[index] && fromL.admin.cocoFlow2[index].setIcon" 
                                        class="footListConimgPic"
                                        :src="fromL.admin.cocoFlow2[index].setIcon" alt="">
                                    <img v-else class="footListConimgPic" :src="JSON.parse(item.json).icon" alt="">
                                    
                                    <!-- <img v-else class="footListConimgPic" :src="require('../assets/img/cocoflow2.svg')" alt=""> -->
                                </div>
                                <div class="TabListName">
                                    <el-tooltip class="item" effect="light" :content="item.name" placement="bottom">
                                        <span>
                                            {{ item.name }}
                                        </span>
                                    </el-tooltip>
                                </div>
                                <div class="TabListBri">
                                    <el-tooltip class="item" effect="light" :content="item.detail" placement="bottom">
                                        <span>
                                            {{ item.detail }}
                                        </span>
                                    </el-tooltip>
                                </div>
                            </div>
                        </div>
        <!-- 
                        <div class="footList2">
                            <div class="footList2Tit">
                                常用应用
                            </div>

                            <div class="footListCon6" v-for="(item,index) in CocoFlowList" @click="openNewWindow(item)" :key="index+'4p'">
                                <div class="footListConimg">
                                    <img style="margin-bottom: 12px;height: 24px;width: 22px;" :src="JSON.parse(item.json).icon" alt="">
                                </div>
                                <div class="TabListName">{{ item.name }}</div>
                                <div class="TabListBri">
                                    <el-tooltip class="item" effect="light" :content="item.detail" placement="bottom">
                                        <span>
                                            {{ item.detail }}
                                        </span>
                                    </el-tooltip>
                                </div>
                                <div class="cha" @click.stop="delApp(item.lid)">
                                    <img style="width: 15px;" src="../assets/img/cha.svg" alt="">
                                </div>
                            </div>

                            <div v-for="(i,index) in (4 - CocoFlowList.length)" @click="openUsuallyApp" 
                            :key="index+'3p'" class="footListCon2">
                                <div style="margin-bottom: 8px;font-size: 40px;color: #0354D7;">
                                    <img src="../assets/img/add.svg" alt="">
                                </div>
                            </div> 
                        </div> -->
                    </div>
                    
                </div>
        </template>
    
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '../store'
import { API_CONFIG } from "@/common/apiConfig";
import { myMixin } from "@/mixins/mixin.js"
import { selectliyuanByIc2SZ } from "@/api/user";
// import axios from '@/common/axios.config'; // 引入 axios 配置实例

    export default {
        mixins: [ myMixin ],

        computed: {
            ...mapGetters(['userinfo','userinfo2','fromL']),
            // 如果hk，com没有图标，默认使用cn的
            AppCon(){
                return function(c) {
                    let k = JSON.parse(JSON.stringify(c))
                    // console.log('k',k);
                    
                    // 获取属于区域的url
                    let data = k.filter(e=>{
                        // return e.region == this.roleUser.schoolArea || e.region == this.roleUser.orgArea
                        return e.region == this.$region
                    })
                    // console.log('data',data);

                    // 设置默认的图标(所在区域没有hover图标默认使用cn图标)
                    let data2 = k.filter(e=>{
                        return e.region == 'cn'
                    })
                    // console.log('data2',data2);
                    
                    // 如果hk，com没有图标，默认使用cn的
                    if (!data[0].activeIcon){
                        data[0].activeIcon = data2[0].activeIcon
                    }
                    if (!data[0].defaultIcon){
                        data[0].defaultIcon = data2[0].defaultIcon
                    }
                    if (!data[0].hoverIcon){
                        data[0].hoverIcon = data2[0].hoverIcon
                    }
                    if (!data[0].icon){
                        data[0].icon = data2[0].icon
                    }
                    if (!data[0].platformIcon){
                        data[0].platformIcon = data2[0].platformIcon
                    }
                    // console.log('data3',data);
                    
                    return data
                };
            },

            // 判断是否被添加过
            isAdd(){
                return function(val){
                    const difference = val.filter(item1 => 
                        !this.CocoFlowList.some(item2 => item1.id === item2.id)
                    );
                    return difference
                }
            },
            roleUser(){
                return Object.keys(this.userinfo2).length != 0 ? this.userinfo2 : this.userinfo
            }
        },
        data() {
            return {
                enterClassDialogVisible:false,
                code:'',
                redirect: this.$route.query["redirect"],
                enterClassLoading:false,
                colfour:["56ca35f7-1b6e-11f0-a66a-005056924926","2525c432-c05d-11f0-a424-005056924926"],
                // 判断链接时liyuan还是admin的
                // platform:'',
                // 判断链接时beta还是cloud的
                betaL: this.$region,
                loading:false,
                // 管理平台添加常见cocoFlow应用
                admincocoFlow:[],
                // 用户ai应用数组
                CocoFlowList:[],
                // 平台工具 
                tabList:[],
                // 后台未设置常用应用后使用默认应用，这些是默认应用的头像
                appImgList:[
                    require('../assets/img/img7.svg'),
                    require('../assets/img/img8.svg'),
                    require('../assets/img/img2.svg'),
                    require('../assets/img/img6.svg'),
                    require('../assets/img/img5.svg'),
                    require('../assets/img/img1.svg'),
                    require('../assets/img/img4.svg'),
                    require('../assets/img/img3.svg'),
                ],
                // 荔园首页工具模块
                liyuanTab:[
                    {toolId:'CourseCon',name:'课程建设',icon:require('../assets/lytop/kj.svg'),hoverIcon:require('../assets/lytop/kj.gif'),hovered:false,clearL:true},
                    {toolId:'teacherDevelop',name:'教师发展',icon:require('../assets/lytop/kz.svg'),hoverIcon:require('../assets/lytop/kz.gif'),hovered:false,clearL:true},
                    {toolId:'aiOffice',name:'智能教务',icon:require('../assets/lytop/kg.svg'),hoverIcon:require('../assets/lytop/kg.gif'),hovered:false,clearL:true},
                    {toolId:'lyStudentEva',name:'学生评价',icon:require('../assets/lytop/jg.svg'),hoverIcon:require('../assets/lytop/jg.gif'),hovered:false,clearL:true},
                    {toolId:'schoolSafe',name:'平安校园',icon:require('../assets/lytop/xy.svg'),hoverIcon:require('../assets/lytop/xy.gif'),hovered:false,clearL:true},
                ],
                // 荔园集团下的学校 
                mergedList: [
						"3823a6a5-1b6e-11f0-a66a-005056924926",
						"21d6b367-1b6e-11f0-a66a-005056924926",
						"1a1a172d-1b6e-11f0-a66a-005056924926",
						"1197f86b-1b6e-11f0-a66a-005056924926",
						"f235659b-1b6d-11f0-a66a-005056924926",
						"d87b62d3-1b6d-11f0-a66a-005056924926",
						"c25ea59b-1b6d-11f0-a66a-005056924926",
                        // "0fec3a8a-ad04-11ed-b13d-005056b86db5" //这个是测试学校的
				]
                // "292e34dc-1b6e-11f0-a66a-005056924926", //笔架山学习单独设置所以不用这个了

            }
        },
        methods: {
            enterClassbtn(){
                this.enterClassDialogVisible = true;
               
            },
            closeEnterClass(){
                this.enterClassDialogVisible = false;
                this.code = '';
            },
            async enterClassConfirm(){
                if (this.code == '') {
                    this.$message.error(this.lang.enterrandomcode);
                    return
                }
                this.nextStepsLoading = true;
                let params = {
                    code: this.code,
                    oid: this.roleUser.organizeid,
                    orgL: this.roleUser.org,
                };
                console.log('params',params);
                await selectliyuanByIc2SZ(params)
                .then(async (res) => {
                    console.log('res',res.data[0][0]);
                    
                    if (res.data && res.data[0] && res.data[0][0] && res.data[0][0].courseId) {
                        this.nextStepsLoading = false;
                        let courseId = res.data[0][0].courseId
                        console.log('courseId',courseId);
						let classData = await this.getClass(res.data[0][0].classid,this.roleUser.organizeid);
                        console.log('classData',classData);
                        
                        const inClass = classData.some(item => item.userid == this.roleUser.userid)
                        if (inClass) {
                            this.$router.push({
                                path: "/",
                                query: { 
                                    courseid: courseId,
                                    type: ''
                                },
                            });
                        } else {
                            this.$message.error(this.lang.notinthisclass);
                        }
                    }else{
                        this.nextStepsLoading = false;
                        this.$message.error(this.lang.codenotexist);
                    }
                })
                .catch(err => {
                    this.nextStepsLoading = false;
                    this.$message.error(this.lang.Failedtooldata);
                    console.log('err',err);
                });
                
            },
            // 根据随机码获取学生
            async getClass(classId,oid) {
                return new Promise((resolve,reject) => {
                let params = [
                    {
                        functionName: API_CONFIG.ajax_selectSnameByCidAndOid.functionName, // 调用存储过程的名称
                        cid: classId,
                        oid:oid
                    },
                ];

                this.$ajax
                    .post(API_CONFIG.baseUrl, params)
                    .then((res) => {
                        // this.classJuri = res.data[0];
                        console.log('res.data[0]',res.data[0]);
                        resolve(res.data[0]);
                        // this.classJuri = this.groupByName(res.data[0])
                        // console.log('this.classJuri',this.classJuri);
                        // this.nextStepsLoading = false
                            
                        // this.steps = 2;
                    })
                    .catch((err) => {
                        // this.nextStepsLoading = false

                        console.error(err);
                        reject([]);
                    });
                });
            },
            getSuffixData(){
                this.SuffixData = this.roleUser.org;
            },
            // 轮播图跳转链接
            gotoBanner(val){
                if (val == '') return
                window.open(val, "_blank");
            },
            // 首页平台应用浮动效果
            setHovered(index, value) {
                this.tabList[index].hovered = value;
            },
            // 首页liyuan平台应用浮动效果
            lysetHovered(index, value) {
                this.liyuanTab[index].hovered = value;
            },
            // 获取cocoFlow2应用
            getData(){
                let cocoFlowCopy = []
                if (this.fromL.admin.cocoFlow2 && this.fromL.admin.cocoFlow2.length) {
                    cocoFlowCopy = this.fromL.admin.cocoFlow2.map(item => item.id);
                }else{
                    return
                }
                    // let appList=[
                    //     "4aed8607-19e1-11f0-a66a-005056924926",
                    //     "337f9d06-1eb6-11f0-a66a-005056924926",
                    //     "52b4aae8-088d-11f0-b508-005056924926",
                    //     "5c95f692-1460-11f0-bad1-005056924926"
                    // ]

                    let params = [
                        {
                            functionName: API_CONFIG.ajax_AdminApp.functionName,
                            con: cocoFlowCopy.join(','), 
                        },
                    ];
                
                this.$ajax
                    .post(API_CONFIG.baseUrl, params)
                    .then((res) => {
                        let _data = res.data[0];

                        this.CocoFlowList = cocoFlowCopy.map(id => _data.find(item => item.id === id));

                    })
                    .catch((err) => {
                        console.log(err);
                        this.$message.error(this.lang.Failedtooldata);
                    });
            },
            // 筛选可用平台工具,判断是否管理员可见，去除已删除工具
            siftCoco(){
                let data = []
                let val = JSON.parse(JSON.stringify(this.roleUser.type == 1 ? this.fromL.admin.index.list : (this.fromL.admin.index.stuList ? this.fromL.admin.index.stuList : this.fromL.admin.index.list)))
                
                // 用户是管理员全部展示
                // if (this.roleUser.type == 2) {
                //     val.forEach( e =>{
                //         if (e.id == 'c59dac89-0bac-11f0-baea-005056924926' || e.id == "dd87149c-1f52-11f0-a66a-005056924926") {
                //             data.push(e)
                //         }
                //     })
                // } else 
                if (this.roleUser.type == 1 && this.roleUser.role == 1) {
                    val.forEach( e =>{
                        if (e.status == 0) {
                            data.push(e)
                        }
                    })
                } else {
                    // 用户不是管理员，判断是否为用户可见 isAdmin 0普通用户 status是否被删除
                    val.forEach( e =>{
                        if (e.isAdmin == '0' && e.status == 0) {
                            data.push(e)
                        }
                    })
                }

                this.tabList = data
                // console.log('this.tabList',this.tabList);
            },
            // 获取cocoFlow应用
            getAdmincocoFlow(){
                // 筛选可用平台工具,判断是否管理员可见，去除已删除工具
                this.siftCoco()
                let appList= []

                if (this.fromL.admin.cocoFlow.length > 0) {
                    appList = this.fromL.admin.cocoFlow.map(item => item.id);
                } else {
                    if(this.$region == 'cn' || this.$region == 'com' || this.$region == 'beta'){
                        appList= [
                            "d1edef14-ef6f-11ef-b508-005056924926",
                            "701615ab-ffe8-11ef-b508-005056924926",
                            "a8781a86-00d8-11f0-b508-005056924926",
                            "ee61f383-0311-11f0-b508-005056924926",
                            "38ee6402-0539-11f0-b508-005056924926",
                            "1c83613c-ffb7-11ef-b508-005056924926",
                            "0d3d87bd-00b6-11f0-b508-005056924926",
                            "2d05a12a-f0e7-11ef-b508-005056924926",
                        ]
                    }else if (this.$region == 'hk') {
                        appList= [
                            "442a04e5-052f-11f0-b508-005056924926",
                            "92ea02c5-02db-11f0-b508-005056924926",
                            "44c8e974-0f97-11f0-bad1-005056924926",
                            "35a9395c-5009-11f0-bf32-005056924926",
                            "746a4eb1-04b1-11f0-b508-005056924926",
                            "d3637872-0314-11f0-b508-005056924926",
                            "2da0f271-0557-11f0-b508-005056924926",
                            // "2d05a12a-f0e7-11ef-b508-005056924926",
                        ]
                    }
                }
                 let params = [
                        {
                            functionName: API_CONFIG.ajax_AdminApp.functionName,
                            con: appList.join(',') 
                        },
                    ];
                    
                    this.$ajax
                        .post(API_CONFIG.baseUrl, params)
                        .then((res) => {
                            // console.log('res',res);
                            
                            let _data = res.data[0]
                            
                            let appli = appList.map(id => _data.find(item => item.id === id));
                            // console.log('appli',appli);
                            let allCon = appli.filter(Boolean);

                            this.admincocoFlow = allCon.slice(0,7)


                        })
                        .catch((err) => {
                            console.log(err);
                            this.$message.error(this.lang.Failedtooldata);
                        });
            },

            // 打开平台应用
            async openApp(val){
                if (this.appSign == "cocobookllm" && val.toolId != "cocobookllm") {
                    this.$confirm(this.lang.ssSwitchwillnotcachedatapage, this.lang.tip, {
                        confirmButtonText: this.lang.confirm,
                        cancelButtonText: this.lang.Cancel,
                        type: "warning",
                    })
                    .then(() => {
                        this.openAppCopy(val)
                    })
                    .catch(() => {
                        console.log('取消');
                    });
                }else{
                    this.openAppCopy(val)
                }
            },
            async openAppCopy(val){
                console.log('val',val);
                let kk = ['crossstysys','bjsToppersonTea',"learningtea","bjstoppersonstu"]
                if(kk.includes(val.toolId)){
                    return this.$message.info("即将上线，敬请期待");
                }
                // 点击相同应用不刷新
                if (this.appSign == val.toolId) return
                // 更新标识
                await store.commit('user/SET_AppSIGN', val.toolId)
                
                let url = ''
                val.url.forEach(e => {
                    if (e.region == this.$region) {
                        url = e.url
                    }
                });

                let _userinfo = this.roleUser, //登录用户信息
                { userid: _userid, organizeid: _oid, type: _type, org: _org, role: _role, classid: _classId } = _userinfo; // 解构赋值获取用户信息
                const _TscreenType = 1, _SscreenType = 3; // 常量定义
                let queryString = ''
                if(val.argumentList && val.argumentList.length){
                    const paramsMap = {
                    userid: _userid,
                    org: _org,
                    oid: _oid,
                    tType: _type,
                    role: _role,
                    classId: _classId,
                    TscreenType: _TscreenType,
                    SscreenType: _SscreenType
                    };
                    
                    const canshu = val.argumentList
                    .filter(param => paramsMap[param] !== undefined || param === 'type')
                    .map(param => param === 'type' ? `tType=${paramsMap['tType']}` : `${param}=${paramsMap[param]}`);

                    queryString = canshu.length ? (url.includes('?') ? '&' : '?') + canshu.join('&') : ''; // 生成查询字符串
                }

                let _url = url + queryString
                // if(val.toolId == 'study' && this.roleUser.type == 2){
                //     _url = _url.replace(/([?&])classId=([^&]*)/, '$1cid=$2');
                // }else if (val.toolId == "AIPopCourse") {
                //     // 为了隐藏ai通识课（ai6）侧边栏与顶部 
                //     _url = _url +'&gotype=1'
                // }else if (val.toolId == "artintellCou") {
                //     // 笔架山人工智能课程（ai6）专属样式
                //     _url = _url +'&gotype=bjs'
                // }else if (val.toolId == "classroomOb" || val.toolId == "claevasys") {
                //     // 新版课堂观察 课堂教学评价系统（课堂观察系统）
                //     _url = url + queryString +'&showIntroduceType=1'
                // } else if (val.toolId == "crossstysys") {
                //     // 跨学科学习系统（协同建构）
                //     _url = url + queryString +'&ly=1&person=liyuan'
                // }
                console.log('_url',_url);

                let pl = {json:_url ,stateL :true,toolId :val.toolId}
                
                this.$emit('cutUrl',pl)

                this.addOp3('1', "", { type:this.prefixL + val.toolId + (this.roleUser.type == 1 ? '_teacher' : '_student') + "_open" }, "success")
                
            },
            async openApp2(val){
                if (this.appSign == "cocobookllm" && val.toolId != "cocobookllm") {
                    this.$confirm(this.lang.ssSwitchwillnotcachedatapage, this.lang.tip, {
                        confirmButtonText: this.lang.confirm,
                        cancelButtonText: this.lang.Cancel,
                        type: "warning",
                    })
                    .then(() => {
                        this.openApp2Copy(val)
                    })
                    .catch(() => {
                        console.log('取消');
                    });
                }else{
                    this.openApp2Copy(val)
                }
            },
            async openApp2Copy(val){
                let url = ''
                let argumentList = ['userid', 'oid', 'org','role','tType']
                // console.log('openApp2betaL',this.betaL);
                
                if (this.$region == 'beta') {
                    url = `https://beta.pbl.cocorobo.cn/pbl-teacher-table/dist/#/${val.toolId}`
                }else{
                    url = `https://pbl.cocorobo.cn/pbl-teacher-table/dist/#/${val.toolId}`
                }


                // return
                // 点击相同应用不刷新
                // if (this.appSign == val.toolId) return
                // 更新标识
                await store.commit('user/SET_AppSIGN', val.toolId)


                let _userinfo = this.roleUser, //登录用户信息
                { userid: _userid, organizeid: _oid, type: _type, org: _org, role: _role, classid: _classId } = _userinfo; // 解构赋值获取用户信息
                const _TscreenType = 1, _SscreenType = 3; // 常量定义
                let queryString = ''
                if(argumentList && argumentList.length){
                    const paramsMap = {
                    userid: _userid,
                    org: _org,
                    oid: _oid,
                    tType: _type,
                    role: _role,
                    classId: _classId,
                    TscreenType: _TscreenType,
                    SscreenType: _SscreenType
                    };
                    
                    const canshu = argumentList
                    .filter(param => paramsMap[param] !== undefined || param === 'type')
                    .map(param => param === 'type' ? `tType=${paramsMap['tType']}` : `${param}=${paramsMap[param]}`);

                    queryString = canshu.length ? (url.includes('?') ? '&' : '?') + canshu.join('&') : ''; // 生成查询字符串
                }

                let _url = url + queryString
                console.log('_url',_url);

                let pl = {json:_url ,stateL :true,toolId :val.toolId,clearL:val.clearL}
                
                this.$emit('cutUrl',pl)

                this.addOp3('1', "", { type:this.prefixL + val.toolId + (this.roleUser.type == 1 ? '_teacher' : '_student') +  "_open" }, "success")
            },
            // 打开CocoFlow应用
            openNewWindow(val) {
                console.log('openNewWindow',val);
                // 基本用法：打开指定 URL
                window.open(val.url, "_blank");
                this.addOp3('1', "", {id :val.id,name:val.name ,type:this.prefixL + (this.roleUser.type == 1 ? '_teacher' : '_student') + "appstoreOpen" }, "success")

            },
             // 打开常见应用弹框
            async lookMore(){
                let val = ''
                if (this.mergedList.includes(this.roleUser.org)) {
                    val = {
                        id: "746ce524-0bae-11f0-baea-005056924926",
                        toolId: "appStoreLiYuan",
                        dialogWidth: '100',
                        dialogHeight: '100',
                        description: "荔园的CocoFlow",
                        isAdmin: '0',
                        argumentList: "[\"userid\",\"oid\",\"org\",\"role\"]",
                        url: "[{\"region\":\"cn\",\"url\":\"https://app.cocorobo.cn/#/\",\"icon\":\"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/appStore1743150350993.png\",\"name\":\"AI应用\",\"platformIcon\":\"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/appStore1743150353110.png\",\"activeIcon\":\"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/Property%201%3DDefault%20%281%291746585029787.svg\",\"defaultIcon\":\"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/Property%201%3DDefault1746585025868.svg\",\"hoverIcon\":\"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/Property%201%3DDefault%20%281%291746585032396.svg\"},{\"region\":\"beta\",\"url\":\"https://beta.app.cocorobo.cn/#/\",\"icon\":\"\",\"name\":\"AI应用\",\"platformIcon\":\"\",\"activeIcon\":\"\",\"defaultIcon\":\"\"},{\"region\":\"hk\",\"url\":\"https://app.cocorobo.hk/#/\",\"icon\":\"\",\"name\":\"CocoFlow\",\"platformIcon\":\"\",\"activeIcon\":\"\",\"defaultIcon\":\"\"},{\"region\":\"com\",\"url\":\"https://app.cocorobo.com/#/\",\"icon\":\"\",\"name\":\"CocoFlow\",\"platformIcon\":\"\",\"activeIcon\":\"\",\"defaultIcon\":\"\"}]",
                        json: "\"\"",
                        status: "0"
                    }
                }else{
                    val = {
                        id: "dd87149c-1f52-11f0-a66a-005056924926",
                        toolId: "appStore",
                        dialogWidth: '100',
                        dialogHeight: '100',
                        description: "CocoFlow",
                        isAdmin: '0',
                        argumentList: "[\"userid\",\"oid\",\"org\",\"role\"]",
                        url: "[{\"region\":\"cn\",\"url\":\"https://app.cocorobo.cn/#/\",\"icon\":\"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/appStore1743150350993.png\",\"name\":\"CocoFlow\",\"platformIcon\":\"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/appStore1743150353110.png\",\"activeIcon\":\"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/marketeq_home-alt-3%20%282%291744697451173.svg\",\"defaultIcon\":\"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/marketeq_home-alt-3%20%281%291744697448514.svg\"},{\"region\":\"beta\",\"url\":\"https://beta.app.cocorobo.cn/#/\",\"icon\":\"\",\"name\":\"CocoFlow\",\"platformIcon\":\"\",\"activeIcon\":\"\",\"defaultIcon\":\"\"},{\"region\":\"hk\",\"url\":\"https://app.cocorobo.hk/#/\",\"icon\":\"\",\"name\":\"CocoFlow\",\"platformIcon\":\"\",\"activeIcon\":\"\",\"defaultIcon\":\"\"},{\"region\":\"com\",\"url\":\"https://app.cocorobo.com/#/\",\"icon\":\"\",\"name\":\"CocoFlow\",\"platformIcon\":\"\",\"activeIcon\":\"\",\"defaultIcon\":\"\"}]",
                        json: "\"\"",
                        status: "0"
                    }
                }

                val.url = JSON.parse(val.url)
                val.argumentList = JSON.parse(val.argumentList)
                

                this.openApp(val)
            },
        },
        mounted(){
            // 获取浏览器缓存中的随机码
            const stuInfoCode = window.sessionStorage.getItem("stuInfoCode");
            if(stuInfoCode){
                this.code = JSON.parse(stuInfoCode);
                this.enterClassConfirm()
            }
        }
    }
</script>


<style scoped>
.enterClassTit2{
    background: #3681FC;
    padding: 0 20px !important;
    height: 36px;
    line-height: 36px;
    color: #fff;
}
.enterClassInput{
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 15px 20px;
    box-sizing: border-box;
}
.enterClassDialog {
    width: 600px;
    margin: auto;
    margin-top: 8vh;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
}

.enterClassBtn{
    width: 278px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid #3681FC;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #3681FC;
    cursor: pointer;
}
.enterClassBtn:hover{
    background-color: #E8F3FF;
}
@media screen and (max-width: 1024px) {
  .footConLeft{
      width: 290px !important;
   }
}
 /*指示器按钮*/
.CarO >>> .el-carousel__button {
    width: 10px;
    height: 10px;
    border: none;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.2);
}
/*指示器激活按钮*/
.CarO >>> .is-active .el-carousel__button {
  background: #0663FE;
}
.topPageCon{
    display: flex;
    flex-direction: column;
    height: 100%;
}
/* 顶部区域 */
.topBlock{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.topTit{
    font-size: 30px;
    height: 100%;
    color: #000;
    font-weight: 600;
}
.topDetail{
    color: #64748B;
    margin-top: 16px;
}



/* 平台应用 */
.TabList{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px; /* 网格间距 */
    margin: 26px 0 40px;
}
.TabListF{
    grid-template-columns: repeat(4, 1fr);
}
.TabListAdmin{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    gap: 20px; /* 网格间距 */
    margin: 56px 0 40px;
}

.TabListAll{
    position: relative !important;
    display: flex;
    height: 140px;
    justify-content: flex-end;
}
.TabListAll2{
    position: relative !important;
    display: flex;
    height: 140px;
    justify-content: center;
    align-items: end;
    background: #fff;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;
}
.tabTit{
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 20px;
    line-height: 100%;
}
.imgApp{
    width: 120px;
    height: 140px;
    object-fit: contain;
    position: absolute;
    top: 50%;
    transform: translate(0,-50%) !important;
    left: 0px;
}
.TabListCon{
    width: 170px;
    height: 140px;
    padding: 24px;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 10px;
    width: calc(100% - 60px);
    transition: all 0.3s ease; /* 统一过渡效果 */
    background-size: 20px 20px;
    cursor: pointer;
    box-shadow: 0px 4px 10px 0px #0000000D;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: end;
}
.TabListCon:hover{
    width: calc(100% - 50px);
    height: 125px;
    margin-right: 10px;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
}
.TabListCon:hover TabListBri{
    -webkit-line-clamp: 2;
    width: 150px;
}
.TabListName{
    color: #1f2937;
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 5px;
    margin-bottom: 4px;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    /* overflow: hidden; */
    text-align: right;
    /* text-overflow: ellipsis; */
}
.TabListName2{
    color: #1f2937;
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 5px;
    margin-bottom: 4px;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.TabListBri{
    color: rgba(0,0,0,.6);
    font-size: 14px;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.tabCon{
    transition: all 0.3s ease; /* 统一过渡效果 */
    border-radius: 10px;
    cursor: pointer;
}

/* 常见应用样式 */
.footCon{
    display: flex;
    /* padding-top: 30px; */
    /* height: 350px; */
    justify-content: space-between;
    box-sizing: border-box;
    border-radius: 10px;
    /* margin: 80px 0; */
    /* background-image: radial-gradient(#E6F0FF 1px, transparent 1px); */
    background-size: 20px 20px;
}

/* 图片 */
.footConLeft{
    width: 375px;
    min-width: 150px;
    box-sizing: border-box;
    display: flex;
    padding-right: 40px;
    object-fit: contain;
}
.footConLeft img{
    min-width: 150px;
    border-radius: 15px;
    object-fit: cover;
    /* object-view-box: inset(0% 12px 30px 30px); */
}
.CutImg{
    width: 100% !important;
    object-view-box: inset(0% 12px 30px 30px);
}
.CocoTit{
    width: 100%;
    min-width: 150px;
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 20px;
    letter-spacing: 10%;
    height: 83px;
    padding: 20px;
    box-sizing: border-box;
    line-height: 83px;
    background: #0663FE;
    border-radius: 12px;
    color: #fff;

}

/* 中间后面设置应用 */
.footList{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, 1fr); /* 创建两行，每行高度相等 */
    gap: 16px; /* 网格间距 */
    flex: 2;
}
/* .footListCon{
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0px 0px 22.4px 0px #0000000D;
    padding: 16px;
    box-sizing: border-box;
    transition: all 0.3s ease; 
    cursor: pointer;
} */
.footListCon,
.footListCon6{
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0px 0px 22.4px 0px #0000000D;
    padding: 16px;
    box-sizing: border-box;
    transition: all 0.3s ease; /* 统一过渡效果 */
    cursor: pointer;
    position: relative;
    display: flex;
    flex-direction: column;
}
.footListCon6:hover .cha{
    display: block;
}

.footListCon6:hover{
    transform: translate(-5px,-10px); /* 向上位移 */
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
}
.footListCon:hover{
    transform: translate(-5px,-10px); /* 向上位移 */
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
}

.footListConimg{
    height: 40%;
    padding-top: 8px;
    box-sizing: border-box;
}
.footListConimgPic{
    margin-bottom: 12px;height: 40px;width: 40px;object-fit: contain;
}
.cha{
    display: none;position: absolute;top: 10px;right: 10px;
}
.footListCon:hover .cha{
    display: block;
}

/* 添加常见应用区域 */
.footList2{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr); /* 创建两行，每行高度相等 */
    gap: 16px;
    flex: 1;
    position: relative;
}
.footList2Tit{
    position: absolute;
    top: -30px;
    left: 0;
    font-family: PingFang SC;
    color: #000;
}

.footListCon2{
    display: flex;
    cursor: pointer;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    border: 1px dashed  #000000;
    box-sizing: border-box;
    border-radius: 12px;
    border-width: 1px;
    background-color: #E5E5E5;
}
.footListCon2:hover {
    background: #C9C9C9;
}



/* 弹框 */
.moreDia >>> .el-dialog{
    border-radius: 10px;
}
.moreDia >>> .el-dialog__body{
    height: 500px;
    /* overflow: auto; */
    border-top: 1px #e7e7e7 solid;
}
/* 对号 */
.top{
    display: flex;
    height: 154px;
    justify-content: space-between;
    background-color: #fff;
    align-items: center;
    padding: 24px;
    box-sizing: border-box;
    margin-bottom: 14px;
    border-radius: 10px;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)
}

.AppList{
    flex-wrap: wrap;display: flex;
    justify-content: space-between;
    border: 1px rgb(243 244 246 / var(--tw-border-opacity, 1)) solid;
    border-radius: 10px;padding: 16px;box-sizing: border-box;
    position: relative;
}
.appImg{
    width: 48px;
    height: 48px;
    border-radius: 50%;
    object-fit: cover;
}
.con{
    flex: 1;
    margin-left: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.tit{
    color: #1f2937;font-size: 16px;height: 24px;line-height: 24px;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.bri{
    color: #6b7280;font-size: 12px;height: 16px;line-height: 16px;
    overflow: hidden;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.enterClass{
    display: flex;
    justify-content: center;
    height: 100%;
}
.enterClassTit{ 
    margin-top: 15%;
    width: 278px;
    height: 56px;
    border-radius: 20px;
    border: 1px solid #3681FC;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #3681FC;
    background-color: #fff;
    cursor: pointer;
    font-family: PingFang SC;
    font-size: 20px;
}
.enterClassTit:hover{
    background-color: #E8F3FF;
}
</style>